/**
* Created by CHENRC2 on 2018-1-10.
*/
<template>
  <div>
    <div class="logo">
      <img src="../../../../assets/midea_logo.png" v-if="!collapse" class="imgbig">
      <i class="mf mf-midea mf-3x imglittle" v-else></i>
    </div>
    <Input v-model="menuKey" :placeholder="$t('common.searchKeyWord')" size="small" style="margin:10px 0 0 20px;width:100px;" @on-change="menuSearch"></Input>
    <ul class="m-menu m-menu-dark m-menu-vertical menu-item gsc-menus-sidebar">
      <li :class="{'m-menu-submenu': true, 'm-menu-opened': menu.open}" v-for="(menu, index) in menuList" :key="index">
        <div class="m-menu-submenu-title" @click="menuTileClick(index, menu.fdKey)">
          <i v-if="menu.fdFrontIcon" :class="menu.fdFrontIcon" slot="icon"></i><i class="text" :title="menu.fdName">{{menu.fdName}}</i><i class="m-icon m-icon-ios-arrow-down m-menu-submenu-title-icon"></i>
        </div>
        <div>
          <ul :class="{'m-menu' : true, 'm-menu-hide': true, 'm-menu-show': menu.open}" :style="{top: offsetY}">
            <li :class="{'m-menu-item': true, 'm-menu-item-active': link === menu.fdFrontLink}" v-for="(menu, index) in menu.subNodes" :key="index" @click="goRouter(menu.fdFrontLink, menu)">
              <Icon v-if="menu.fdFrontIcon" :type="menu.fdFrontIcon" slot="icon"></Icon>{{menu.fdName}}
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>
<style lang='less' scoped>
@import 'styles.less';
</style>
<script>
import { mapGetters } from 'vuex';

export default {
  props: ['collapse'],
  data() {
    return {
      checkedIndex: '',
      link: '',
      offsetY: '',
      menuKey: '',
      menuBackUp: {},
      menuList: []
    };
  },
  computed: {
    menuitemClasses() {
      return ['menu-item', this.collapse ? 'collapsed-menu' : ''];
    },
    ...mapGetters(['menus', 'breadcrumb'])
  },
  methods: {
    menuTileClick (index, fdKey) {
      this.menuList[index].open = !this.menuList[index].open;
    },
    // 菜单导航
    menuSearch () {
      let menu = [];
      this.menuBackUp.forEach((item) => {
        let subNodes = item.subNodes && item.subNodes.filter((item2) => item2.fdName.indexOf(this.menuKey.replace(/(^\s*)|(\s*$)/g, '')) > -1) || [];
        if (item.fdName.indexOf(this.menuKey.replace(/(^\s*)|(\s*$)/g, '')) > -1) {
          this.menuPush(item, menu, subNodes);
          if (subNodes.length === 0) {
            menu.push(item);
          }
        } else {
          this.menuPush(item, menu, subNodes);
        }
      });
      this.menuList = menu;
    },
    menuPush (item, menu, subNodes) {
      if (subNodes.length > 0) {
        menu.push({
          ...item,
          subNodes,
          open: this.menuKey !== ''
        });
      }
    },
    setOffsetY (event) {
      let dom = document.getElementsByClassName('m-layout-sider-collapsed')[0];
      let menuItemDom = event.currentTarget.childNodes[2].childNodes[0];
      let height = event.currentTarget.childNodes[2].childNodes[0].offsetHeight;
      if (dom) {
        let Y = event.currentTarget.offsetTop - dom.scrollTop;
        if (Y + height > window.innerHeight) {
          let setStyle = '';
          if (height - dom.scrollTop > window.innerHeight) {
            Y = 80;
            setStyle = window.innerHeight - 80 + 'px';
          } else {
            Y = window.innerHeight - height;
            setStyle = 'auto';
          }
          menuItemDom.style.height = setStyle;
        }
        this.offsetY = `${Y}px`;
      }
    },
    goRouter (link, menu) {
      try {
        this.detailMsg(link);
        // 菜单埋点统计
        let supplierInfo = JSON.parse(localStorage.getItem('supplierInfo'));
        axios.post('/gscapp/homepage/menuUseSum', {
          vendorCode: supplierInfo.vendorCode,
          menuCode: menu.fdKey,
          menuDesc: menu.fdName,
          user: supplierInfo.userName
        });
      } catch (err) {
        console.log(err);
      }
      this.link = link;
      if (link.indexOf('open=browser') > -1) {
        window.open(link);
      } else {
        this.$router.push(link);
      }
    }
  },
  watch: {
    '$route' (obj) {
      console.log('newVal', obj);
      this.link = obj.fullPath;
    }
  },
  mounted() {
    const moduleLink = window.location.href.indexOf('.html') > -1 ? window.location.pathname : window.location.pathname + 'index.html';
    const filterRoutes = this.menus.filter(item => moduleLink.indexOf(item.fdFrontLink) > -1);
    let menus = JSON.parse(JSON.stringify(filterRoutes.length ? filterRoutes[0].subNodes : []));
    menus.map((item, index) => {
      menus[index] = {
        ...item,
        open: false
      };
    });
    console.log('menus', menus);
    this.menuList = menus;
    this.menuBackUp = JSON.parse(JSON.stringify(this.menuList));
  }
};
</script>
<style lang="less" scoped>
  .m-menu-dark {
    background: #495060;
  }
  .m-menu-dark.m-menu-vertical.gsc-menus-sidebar {
    .m-menu-submenu-title, .m-menu-item {
      color: #FFF !important;
    }
    .m-menu-submenu .m-menu-item:hover {
      background-color: #3aa2eb !important;
    }
  }
  .m-menu {
    position: static;
  }
  .m-menu-dark.m-menu-vertical .m-menu-item:hover, .m-menu-dark.m-menu-vertical .m-menu-submenu-title:hover {
    background: #495060;
  }
  .m-menu-submenu-title>i, .m-menu-submenu-title span>i {
    margin-right: 5px;
  }
  .m-menu-item>i {
    margin-right: 6px;
  }
  .m-menu-submenu-title {
    display: flex;
    align-items: center;
    .text {
        max-width: 105px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: 5px;
    }
    .m-menu-submenu-title-icon {
        margin: 0;
    }
  }
  .menu-item span {
    display: inline-block;
    overflow: hidden;
    width: 69px;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
    transition: width 0.2s ease 0.2s;
  }
  .menu-item .text {
    font-style: normal;
  }
  .menu-item i {
    transform: translateX(0px);
    transition: font-size 0.2s ease, transform 0.2s ease;
    vertical-align: middle;
  }
  .m-menu-hide {
    max-height: 0;
    overflow: hidden;
    transition: all .3s ease;
  }
  .m-menu-show {
    max-height: 1500px;
  }
  .collapsed-menu span {
    width: 0px;
    transition: width 0.2s ease;
  }

  .collapsed-menu i {
    transform: translateX(5px);
    transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
    vertical-align: middle;
    font-size: 22px;
  }
  .logo {
    height: 64px;
    text-align: center;
    border-bottom: 1px solid #fff;
    .imgbig {
      height: 30px;
      margin-top: 10px;
    }
    .imglittle {
      color: white;
      margin-top: 15px;
    }
  }
.m-menu-vertical .m-menu-submenu-title, .m-menu-vertical .m-menu-item {
  padding: 14px 0 14px 10px;
}
.m-menu-vertical .m-menu-submenu-title-icon {
  float: none;
  top: 0;
}
.m-layout-sider-collapsed {
  .menu-item .text, .m-menu-submenu-title-icon{
    display: none;
  }
  .m-menu-show {
    max-height: 0;
  }
  .m-menu-submenu:hover {
    .m-menu-hide {
      position: fixed;
      left: 30px;
      top: 70px;
      max-height: none;
      width: 160px;
      background: #363e4e;
      z-index: 999;
      overflow-y: auto;
    }
  }
  .m-menu-submenu-title {
    padding-left: 10px;
  }
  .m-menu-vertical .m-menu-item {
    padding-left: 20px;
  }
}
</style>